var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"render-rule-go-json-message"},[(_vm.value.text !== '')?_c('p',[_vm._v(_vm._s(_vm.value.text))]):_vm._e(),(_vm.getJsonString !== '')?_c('RenderCode',{attrs:{"value":_vm.getJsonString},on:{"apply":_vm.onApply}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }